import React, { JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export const PublicRoute: React.FC<{
  children: JSX.Element;
  authed: boolean;
  route: {
    path: string;
    private: boolean;
    element: JSX.Element;
    open?: boolean;
  };
}> = ({ children, authed, route }) => {
  if (route.open) {
    return children ?? <Outlet />;
  }
  if (authed) {
    return <Navigate to="/" replace />;
  }
  return children ?? <Outlet />;
};
